import React from "react";
import "./about.css";
import Info from "./Info";
import Qualification from "../qualification/Qualification";
import Icon from "../ui/Icon";
import BrandIcon from "../ui/BrandIcon";
import { profile } from "../../data/site";

const About = () => (
  <section className="about section" id="about" aria-labelledby="about-title">
    <div className="container">
      <header className="section__head">
        <span className="eyebrow">05 — About</span>
        <h2 id="about-title" className="section__title">
          Engineer first, with a designer’s eye
        </h2>
      </header>

      <div className="about__grid">
        <div className="about__text">
          <p>
            I’m a software engineer and an M.Tech student in Computer Science at Manipal Institute
            of Technology, Bengaluru. I build ML systems, privacy-preserving learning, developer
            tools and GPU software, and I presented a paper on GPU training at IEEE ICNPCV 2026.
          </p>
          <p>
            I document each project the way I would want to find someone else’s: what it does, the
            evidence for it, and what comes next. A few notes here show a bug I caught in my own
            work and how I fixed it.
          </p>
          <p>
            Alongside my B.E. I designed for GDSC and TEDx at MVJCE, which is why I care about how
            interfaces and documentation read.
          </p>
          <div className="about__actions">
            <a className="btn" href={profile.behance} target="_blank" rel="noreferrer">
              <Icon name="design" /> Design work
              <span className="sr-only"> on Behance, opens in a new tab</span>
            </a>
            <a className="btn" href={profile.figma} target="_blank" rel="noreferrer">
              <BrandIcon name="figma" /> Figma
              <span className="sr-only"> design files, opens in a new tab</span>
            </a>
          </div>
        </div>
        <Info />
      </div>

      <Qualification />
    </div>
  </section>
);

export default About;
